import { Injectable } from '@angular/core';
import { environment } from '../../enviroment/enviroment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ProductosService {

  private readonly API_BASE_URL = environment.apiUrl;

  private readonly productosUrl = `${this.API_BASE_URL}/inventario/productos`;
  private readonly productosCargaMasivaUrl = `${this.API_BASE_URL}/inventario/productos/carga-masiva`;

  constructor(private readonly http: HttpClient) { }

  consultarProductosPorAlojamiento(hotelId: string, accessToken: string): Observable<any> {
    return new Observable(observer => {
      this.http.get(`${this.productosUrl}?hotelId=${hotelId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      }).subscribe({
        next: res => {
          observer.next(res);
          observer.complete();
        },
        error: err => observer.error(err)
      });
    });
  }

  obtenerProducto(productId: string, hotelId: string, accessToken: string) {
    return this.http.get<any>(`${this.productosUrl}/${productId}?hotelId=${hotelId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    });
  }

  editarProducto(producto: any, hotelId: string, accessToken: string) {
    return this.http.put<any>(`${this.productosUrl}/${producto.productId}?hotelId=${hotelId}`, producto, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    });
  }

  eliminarProducto(productId: string, hotelId: string, accessToken: string) {
    return this.http.delete<any>(`${this.productosUrl}/${productId}?hotelId=${hotelId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    });
  }

  crearProducto(hotelId: string, data: any, accessToken: string) {
    const payload = {
      hotelId,
      nombre: data.nombre,
      descripcion: data.descripcion,
      precio: data.valor_neto,
      impuesto: data.porcentaje_impuestos,
      stock: data.stock,
    };

    return this.http.post(this.productosUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });
  }

  cargarProductosMasivos(hotelId: string, archivo: File, accessToken: string): Observable<any> {
    return new Observable(observer => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64 = (reader.result as string).split(',')[1];

        const payload = {
          hotelId,
          fileName: archivo.name,
          fileBase64: base64
        };

        this.http.post(this.productosCargaMasivaUrl, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        }).subscribe({
          next: res => {
            observer.next(res);
            observer.complete();
          },
          error: err => observer.error(err)
        });
      };

      reader.readAsDataURL(archivo);
    });
  }
}
